import mapImage from '../OrgImages/mapimage.svg';

export const OrgDetailsShowcase = () => (
  <div className='flex h-full w-full flex-col bg-gradient-to-t from-secondary-brand-50 from-[23%] to-secondary-brand-25 to-[95%] px-12 pb-8 pt-16'>
    <h1 className='m-0 text-display-2xl font-bold text-gray-700 tracking-[-1.2px]'>
      Your mission, their expertise
    </h1>
    <p className='mb-0 mt-4 text-display-xs font-normal text-gray-700'>
      Support when it matters, wherever you are.
    </p>
    <img
      src={mapImage}
      alt=''
      className='mt-auto mb-2 block h-auto w-full'
    />
  </div>
);
